import ICalendarTemplateDetailApp from "ICalendarTemplate/detail/app";
import ICalendarTemplateList from "ICalendarTemplate/list/App";
import ICalendarTemplateNewApp from "ICalendarTemplate/new/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const iCalendarTemplateRoute: RouteObject = {
  path: "icalendartemplate",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ICalendarTemplateList,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: ICalendarTemplateDetailApp,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ICalendarTemplateNewApp,
  }]
};